"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
exports.key = '__immutable';
var empty = immutable_1.Map();
exports.default = (function (name) {
    return (function (_super) {
        __extends(ExtendableRecord, _super);
        function ExtendableRecord(immutable) {
            var _this = _super.call(this, (_a = {}, _a[exports.key] = immutable, _a)) || this;
            return _this;
            var _a;
        }
        ;
        ExtendableRecord.prototype.get = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (_a = _super.prototype.get.call(this, exports.key, empty)).get.apply(_a, args);
            var _a;
        };
        ExtendableRecord.prototype.set = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _immutable = _super.prototype.get.call(this, exports.key, empty);
            var upd = _immutable.set.apply(_immutable, args);
            return _super.prototype.set.call(this, exports.key, upd);
        };
        ExtendableRecord.prototype.update = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _immutable = _super.prototype.get.call(this, exports.key, empty);
            var upd = _immutable.update.apply(_immutable, args);
            return _super.prototype.set.call(this, exports.key, upd);
        };
        ExtendableRecord.prototype.equals = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _immutable = _super.prototype.get.call(this, exports.key, empty);
            return _immutable.equals.apply(_immutable, args);
        };
        ExtendableRecord.prototype.hashCode = function () {
            var _immutable = _super.prototype.get.call(this, exports.key, empty);
            return _immutable.hashCode();
        };
        ExtendableRecord.prototype.toJS = function () {
            var _immutable = _super.prototype.get.call(this, exports.key, empty);
            return _immutable.toJS();
        };
        ExtendableRecord.prototype.toObject = function () {
            return _super.prototype.get.call(this, exports.key, empty).toObject();
        };
        ExtendableRecord.prototype.filter = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _immutable = _super.prototype.get.call(this, exports.key, empty);
            return _immutable.filter.apply(_immutable, args);
        };
        return ExtendableRecord;
    }(immutable_1.Record((_a = {}, _a[exports.key] = void 0, _a), name)));
    var _a;
});
//# sourceMappingURL=createRecord.js.map